export type tLeadAgentDashboardAudience =
  | { kind: 'nobody' }
  | { kind: 'all' }
  | { kind: 'workspaces'; ids: ReadonlySet<string> }
  | { kind: 'invalid'; raw: string };

export type tLeadAgentDashboard = 'v2' | 'current';

export const DASHBOARD_PARAM = 'dashboard';

export const DASHBOARD_V2 = 'v2';

export const DASHBOARD_CURRENT = 'current';

function choiceKey(workspaceId: string): string {
  return `lead_agent_dashboard_${workspaceId.toLowerCase()}`;
}

export function parseDashboard(raw: string | null | undefined): tLeadAgentDashboard | null {
  if (raw === DASHBOARD_V2) return 'v2';
  if (raw === DASHBOARD_CURRENT) return 'current';
  return null;
}

export function readDashboardChoice(workspaceId: string): tLeadAgentDashboard {
  try {
    return parseDashboard(localStorage.getItem(choiceKey(workspaceId))) ?? 'v2';
  } catch {
    return 'v2';
  }
}

export function writeDashboardChoice(workspaceId: string, choice: tLeadAgentDashboard): void {
  try {
    localStorage.setItem(choiceKey(workspaceId), choice);
  } catch {
    return;
  }
}

const WID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function parseLeadAgentDashboardAudience(raw: string | undefined): tLeadAgentDashboardAudience {
  const value = raw?.trim() ?? '';
  if (value === '' || value === 'false') return { kind: 'nobody' };
  if (value === 'all' || value === 'true') return { kind: 'all' };
  const ids = value.split(',').map((id) => id.trim().toLowerCase());
  if (ids.some((id) => !WID.test(id))) return { kind: 'invalid', raw: value };
  return { kind: 'workspaces', ids: new Set(ids) };
}

export function dashboardFor(audience: tLeadAgentDashboardAudience, workspaceId: string): tLeadAgentDashboard {
  if (audience.kind === 'all') return 'v2';
  if (audience.kind === 'workspaces' && audience.ids.has(workspaceId.toLowerCase())) return 'v2';
  return 'current';
}
